import { useState, useRef } from 'react'
import { createPortal } from 'react-dom'
type PositionTypes = 'top' | 'bottom' | 'left' | 'right'
export const BodyTooltip = ({ text, position = 'top', className = '', children, ...rest }: { text: string; position?: PositionTypes; className?: string; children: React.ReactNode } & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
    const [pos, setPos] = useState<{ x: number; y: number } | null>(null)
    const ref = useRef<HTMLButtonElement>(null)

    const showTooltip = () => {
        if (ref.current) {
            const rect = ref.current.getBoundingClientRect()
            setPos({ x: rect.left + rect.width / 2, y: rect.top })
        }
    }

    const hideTooltip = () => setPos(null)

    return (
        <>
            <button type="button" ref={ref} onMouseEnter={showTooltip} onFocus={showTooltip} onBlur={hideTooltip} onMouseLeave={hideTooltip} aria-label={text} className={className} {...rest}>
                {children}
            </button>

            {pos && createPortal(<div className={`tooltip tooltip-open tooltip-info tooltip-${position} z-50`} style={{ position: 'fixed', top: pos.y - 3, left: pos.x }} data-tip={text} />, document.body)}
        </>
    )
}
